import '../plugins/PopupsPlugin.js';
import '../plugins/ResponsiveHelper.js';

// popups init
export default function initPopups() {
  jQuery('.popup-wrap').contentPopup('destroy');
  jQuery('.header-main').contentPopup('destroy');
  jQuery('.login-wrap').contentPopup('destroy');
  jQuery('.filter-dropdown').contentPopup('destroy');
  jQuery('.main-nav .drop-holder, .secondary-nav .drop-holder').contentPopup('destroy');

  jQuery('.popup-wrap').contentPopup({
		mode: 'click',
		popup: '.popup-slide',
		btnOpen: '.popup-opener',
		btnClose: '.popup-close',
		openClass: 'show'
	});

	jQuery('.header-main').contentPopup({
		mode: 'click',
		popup: '.popup-slide',
		btnOpen: '.search-wrap .popup-opener',
		btnClose: '.popup-close',
		openClass: 'show'
	});

	jQuery('.login-wrap').contentPopup({
		mode: 'click',
		popup: '.popup-slide',
		btnOpen: '.popup-opener',
		btnClose: '.popup-close',
		openClass: 'show'
	});

	jQuery('.filter-dropdown').contentPopup({
		mode: 'click',
		popup: '.dropdown',
		btnOpen: '.dropdown-opener',
		openClass: 'dropdown-active'
	});

	ResponsiveHelper.addRange({
		'..1023': {
			'on': function() {
				jQuery('.main-nav .drop-holder, .secondary-nav .drop-holder').contentPopup({
					mode: 'click',
					popup: '.drop',
					btnOpen: 'a:not(:only-child), .back-link',
					openClass: 'show',
					hideOnClickOutside: false,
					onShow: (self) => {
						jQuery('.nav-drop').addClass('active');
					},
					onHide: (self) => {
						clearTimeout(self.scrollTimer);
						self.scrollTimer = setTimeout(() => {
							jQuery('.nav-drop-inner').scrollTop(0);
						}, 150);
						jQuery('.nav-drop').removeClass('active');
					}
				});
			},
			'off': function() {
				jQuery('.main-nav .drop-holder, .secondary-nav .drop-holder').each(function() {
					jQuery(this).contentPopup('destroy');
				});
			}
		},
		'1024..': {
			'on': function() {
				jQuery('.main-nav .drop-holder, .secondary-nav .drop-holder').contentPopup({
					mode: 'click',
					popup: '.drop',
					btnOpen: 'a:not(:only-child), .back-link',
					openClass: 'show',
					hideOnClickOutside: true,
          onShow: (self) => {
            setTimeout(() => jQuery('.header-main').addClass('nav-drop-active'), 0);
          },
          onHide: (self) => {
            jQuery('.header-main').removeClass('nav-drop-active');
          },
				});
			},
			'off': function() {
				jQuery('.main-nav .drop-holder, .secondary-nav .drop-holder').each(function() {
					jQuery(this).contentPopup('destroy');
				});
			}
		}
	});

	jQuery(window).on('mobile-nav:hide', () => {
		jQuery('.main-nav .drop-holder, .secondary-nav .drop-holder').each(function() {
			if (jQuery(this).data('ContentPopup')) {
				jQuery(this).contentPopup('hidePopup');
			}
		});

		jQuery('.nav-drop-inner').scrollTop(0);
	});
}
